import { useState } from "react";
import classNames from "classnames";
import { HiOutlineLightBulb } from "react-icons/hi";

import ModalNodeLight from "./modals/ModalNodeLight";

type NodeLightProps = {
    system: CoreSystem;
    selectedNode: CoreNode | null;
};

export default function NodeLight({ system, selectedNode }: NodeLightProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!selectedNode) {
        return null;
    }

    return (
        <>
            <button
                className={classNames(
                    "flex justify-center items-center gap-2 bg-white text-sm py-2 px-4 border border-gray-400 rounded",
                    selectedNode
                        ? "text-orange-500 hover:text-orange-700"
                        : "text-gray-400"
                )}
                onClick={() => setIsModalOpen(true)}
            >
                <HiOutlineLightBulb fontSize={24} />
                Light
            </button>

            <ModalNodeLight
                system={system}
                selectedNode={selectedNode}
                isOpen={isModalOpen}
                setIsOpen={setIsModalOpen}
            />
        </>
    );
}
